import React from "react";
import { Link } from "gatsby";

import NavbarDesktop from '../Navbar/Navbar'
import NavbarMobile from '../NavbarMobile/NavbarMobile'

class HeaderTemplate extends React.Component {

  componentDidMount() {
    let header = document.querySelector('.header');
    let sticky = header.offsetTop;

    window.onscroll = function() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    };
  }


  render() {
    const {data} = this.props;
    const sitedata = this.props.siteMetadata;

    return (
      <header id="masthead" className="header">
        <div className="container header-container">
          <div className="header__inner">
            <div className="header__logo">
              <div className="logo">
                {sitedata.logoImage
                  ? <Link to={sitedata.logoImage.url}>
                      <img src={sitedata.logoImage.image} alt={sitedata.logoImage.imageAlt} width="196" height="40" />
                    </Link>
                  : null
                }

              </div>
            </div>

            <div className="header__nav">
              <NavbarDesktop data={data}/>
              <NavbarMobile data={data}/>
            </div>

          </div>
        </div>
      </header>
    );
  }

};

const Header = props => {
  if (!props.data) {
    return null;
  }
  const data = props.data.edges[0].node.frontmatter;
  const siteMetadata = props.siteMetadata;

  return <HeaderTemplate data={data} siteMetadata={siteMetadata} />;
};

export { Header };
